
<Popup
  :value="showModal"
  popup-header="Multi-lingual"
  popup-size="sm"
  @input="handlePopupVisibility"
  @close="handlePopupVisibility(false)"
>
  <div>
    <div class="text-body mb-16">Select the required languages:</div>
    <div class="flex flex-col flex-wrap h-368 md:h-256">
      <Checkbox
        v-for="(item, index) in languageOptions"
        :key="index"
        v-model="selectedLanguages"
        :labelName="item.textLabel"
        :value="item.value"
        class="w-1/2 md:w-1/3"
      />
    </div>
    <Button
      id="clear-selections"
      value="Clear All"
      class="w-full button-medium"
      variant="outlined"
      @click.prevent="clearLanguages"
    />
    <Button id="save-selections" value="Save" class="w-full button-medium my-32" @click.prevent="saveLanguages" />
  </div>
</Popup>
